module.exports = __webpack_public_path__ + "static/media/petra.05115ecc.ogg";